module.exports = __webpack_public_path__ + "static/media/add-logo-desktop-es.fdb64030.webp";